import { cn } from '~/utils/cn';

interface TitleAccentCellProps {
  children: React.ReactNode;
  className?: string;
  /** Automation hook for the accent wrapper. */
  testId?: string;
}

/** Fixed accent background for the product-title column — always tinted, unlike `DiffCell` which is diff-status driven. */
export function TitleAccentCell({
  children,
  className,
  testId = 'title-accent-cell',
}: TitleAccentCellProps) {
  return (
    <div className={cn('bg-warning-50 rounded-md p-1.5', className)} data-testid={testId}>
      {children}
    </div>
  );
}
